import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import Picture from '@cotyorg/ccx-atoms/Picture';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import { isSmallBreakpoint } from '../../utils';

const ProductSteps = ({
  currentBreakpoint,
  sectionHeadings,
  productSteps,
  presentationLocale,
}) => (
  <div className="product-steps">
    <div className="grid-container product-steps__content">
      <div className="grid-x grid-margin-x">
        <div className="cell xsmall-16 large-14 large-offset-1 xlarge-12 xlarge-offset-2">
          <div className="grid-x grid-margin-x">
            <div className="cell xsmall-16 medium-8">
              <div className="product-steps__image-box">
                <Picture
                  alt={R.path(['mainImage', 'alt'], productSteps)}
                  src={R.path(['mainImage', 'imageSrc'], productSteps)}
                  srcset={R.path(['mainImage', 'imageSrcset'], productSteps)}
                />

                {!isSmallBreakpoint({ currentBreakpoint }) && (
                  <>
                    <Picture
                      alt={R.path(['secondImage', 'alt'], productSteps)}
                      src={R.path(['secondImage', 'imageSrc'], productSteps)}
                      srcset={R.path(
                        ['secondImage', 'imageSrcset'],
                        productSteps
                      )}
                      extraClass="product-steps__image-box--second"
                    />

                    <Picture
                      alt={R.path(['thirdImage', 'alt'], productSteps)}
                      src={R.path(['thirdImage', 'imageSrc'], productSteps)}
                      srcset={R.path(
                        ['thirdImage', 'imageSrcset'],
                        productSteps
                      )}
                      extraClass="product-steps__image-box--third"
                    />

                    <Picture
                      alt={R.path(['bgImage', 'alt'], productSteps)}
                      src={R.path(['bgImage', 'imageSrc'], productSteps)}
                      srcset={R.path(['bgImage', 'imageSrcset'], productSteps)}
                      extraClass="product-steps__image-box--bg"
                    />
                  </>
                )}
              </div>
            </div>
            <div className="cell xsmall-16 medium-8">
              <div className="product-steps__copy-box">
                <Heading level={3} extraClass="product-steps__heading">
                  {R.path(['howToSteps', 'heading'], sectionHeadings)}
                </Heading>

                {Array.isArray(R.prop('steps', productSteps)) &&
                  R.prop('steps', productSteps).map(
                    ({ heading, description }) => (
                      <div key={uuid()} className="product-steps__item">
                        {R.prop('steps', productSteps).filter(
                          (element) => typeof element === 'object'
                        ).length === 1 &&
                        (presentationLocale === 'es-es' ||
                          'pl-pl' ||
                          'cs-cz') ? (
                          <Paragraph>{description}</Paragraph>
                        ) : (
                          <>
                            <Heading
                              level={5}
                              extraClass="product-steps__step-heading"
                            >
                              {heading}
                            </Heading>
                            <Paragraph>{description}</Paragraph>
                          </>
                        )}
                      </div>
                    )
                  )}
              </div>
            </div>
            {isSmallBreakpoint({ currentBreakpoint }) && (
              <>
                <Picture
                  alt={R.path(['bgImage', 'alt'], productSteps)}
                  src={R.path(['bgImage', 'imageSrc'], productSteps)}
                  srcset={R.path(['bgImage', 'imageSrcSet'], productSteps)}
                  extraClass="product-steps__image-box--bg"
                />
                <div className="cell xsmall-13 xsmall-offset-3">
                  <Picture
                    alt={R.path(['thirdImage', 'alt'], productSteps)}
                    src={R.path(['thirdImage', 'imageSrc'], productSteps)}
                    srcset={R.path(['thirdImage', 'imageSrcSet'], productSteps)}
                    extraClass="product-steps__image-box--third"
                  />
                </div>
                <div className="cell xsmall-13">
                  <Picture
                    alt={R.path(['secondImage', 'alt'], productSteps)}
                    src={R.path(['secondImage', 'imageSrc'], productSteps)}
                    srcset={R.path(
                      ['secondImage', 'imageSrcSet'],
                      productSteps
                    )}
                    extraClass="product-steps__image-box--second"
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

ProductSteps.propTypes = {
  currentBreakpoint: PropTypes.string,
  productSteps: PropTypes.shape({
    imageSrc: PropTypes.string,
    imageSrcSet: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        src: PropTypes.string,
      })
    ),
  }),
  sectionHeadings: PropTypes.shape({
    relatedProducts: PropTypes.shape({
      heading: PropTypes.string,
    }),
    productSteps: PropTypes.shape({
      heading: PropTypes.string,
    }),
    retailers: PropTypes.shape({
      heading: PropTypes.string,
    }),
  }),
  presentationLocale: PropTypes.string,
};

export default ProductSteps;
